import React, {Component} from 'react';



class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    async componentDidMount() {

    }

    render() {
        return (

            <footer className="mt-5 mb-5 text-muted text-center text-small">
                {/*<a href="/p3x-exchange/?mn=0x8c070C3c66F62E34bAe561951450f15f3256f67c">Aritz Masternode</a>*/}
                {/*&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;*/}
                {/*<a href="/p3x-exchange/?mn=0x315cea9d9c15b126a96dbaea663b5eb538fdd090">Minnow Masternode</a>*/}
                <p className="mb-1 mt-4">This is for entertainment only. Play at your own risk.</p>
            </footer>

        );
    }
}

export default Footer;